export const SITE_IDS = {
  navHome: "nav-home",
  navDetails: "nav-details",
  navGallery: "nav-gallery",
  navRsvpCta: "nav-rsvp-cta",
  heroVideo: "hero-video",
  heroSection: "hero-section",
  detailsSection: "details-section",
  ctaSection: "cta-section",
  galleryCta: "gallery-cta",
  photoboothCta: "photobooth-cta",
  socialCta: "social-cta",
  guestAlbumCta: "guest-album-cta",
  creditsSection: "credits-section",
  navCredits: "nav-credits",
  footer: "site-footer",
};

export default SITE_IDS;
